import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';

import type { RecommendationCardItem } from '../../types/types';
import { CardItem } from '../card-item/card-item';

import * as Styled from './cards-module.styles';

type CardsModuleProps = {
  cardItems: RecommendationCardItem[];
  showMoreButton: boolean;
  loadMore: () => void;
  isLoadingMore: boolean;
};

export const CardsModule: React.FC<CardsModuleProps> = ({
  cardItems,
  showMoreButton,
  loadMore,
  isLoadingMore,
}) => {
  return (
    <>
      <Styled.CardsModuleContainer>
        {cardItems.map((item, index) => (
          <li key={index}>
            <CardItem
              id={item.id}
              url={item.url}
              imageSrc={item.imageSrc}
              headline={item.headline}
              description={item.description}
              isFollowed={item.isFollowed}
              pageType={item.pageType}
              urn={item.urn}
            />
          </li>
        ))}
      </Styled.CardsModuleContainer>
      {showMoreButton ? (
        <Styled.ButtonContainer>
          <Button
            variant="secondary"
            onClick={() => loadMore()}
            loading={isLoadingMore}
          >
            <FormattedMessage id="FOLLOWING_RECOMMENDATION_PAGE_BUTTON_LOAD_MORE" />
          </Button>
        </Styled.ButtonContainer>
      ) : null}
    </>
  );
};
